import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

export const VendorDashboard = () => {
  const navigate = useNavigate();


  const [isComplete, setIsComplete] = useState(false);

  const total = 6;
  const done = isComplete ? 6 : 4;
  const progress = useMemo(() => Math.round((done / total) * 100), [done]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="app-container [font-family:'Nunito',Helvetica] text-[#5d4037] pb-16">
        {/* Top bar: avatar + bell */}
        <div className="mt-4 px-4 flex items-center justify-between">
          <div className="w-9 h-9 rounded-full bg-[#ccb357] grid place-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#5d4037">
              <path d="M12 12c2.21 0 4-1.79 4-4S14.21 4 12 4 8 5.79 8 8s1.79 4 4 4z"/><path d="M12 14c-4.42 0-8 1.79-8 4v2h16v-2c0-2.21-3.58-4-8-4z"/>
            </svg>
          </div>
          <h1 className="font-bold text-[18px]">Complete Profile</h1>
          <button className="w-9 h-9 rounded-full grid place-items-center" aria-label="Notifications">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5d4037" strokeWidth="2">
              <path d="M18 8a6 6 0 10-12 0c0 7-3 7-3 7h18s-3 0-3-7"/><path d="M13.73 21a2 2 0 01-3.46 0"/>
            </svg>
          </button>
        </div>

        {/* Welcome card */}
        <div className="mx-4 mt-4 rounded-[16px] bg-[#eadfb7] p-4">
          <p className="font-extrabold">Welcome to Vendor Center!</p>
          <p className="mt-1 text-[14px]">
            Welcome aboard! Complete your profile now to begin selling with Sweet Plate.
          </p>

          {/* Progress bar */}
          <div className="mt-3 w-full h-[14px] rounded-full bg-white relative">
            <div
              className="absolute left-0 top-0 h-[14px] rounded-full bg-[#5d4037]"
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className="mt-2 text-[14px]">
            {done} of {total} steps completed
          </p>

          {/* Small button inside card */}
          <button
            type="button"
            onClick={() => navigate("/verify")}
            disabled={isComplete}
            className={`mt-3 px-4 py-2 rounded-[12px] text-white ${
              isComplete ? "bg-[#5d4037]/60 cursor-not-allowed" : "bg-[#5d4037] hover:opacity-90"
            }`}
          >
            {isComplete ? "Profile Completed" : "Complete Profile"}
          </button>
        </div>

        {/* Quick Actions */}
        <p className="mt-5 px-4 font-extrabold">Quick Actions</p>
        <div className="mt-3 px-4 grid grid-cols-3 gap-4">
          {/* Add products */}
          <div className="flex flex-col items-center">
            <div className="w-[64px] h-[64px] rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#5d4037" strokeWidth="2">
                <path d="M12 5v14M5 12h14"/>
              </svg>
            </div>
            <p className="mt-2 text-[13px]">Add products</p>
          </div>

          {/* View Order */}
          <div className="flex flex-col items-center">
            <div className="w-[64px] h-[64px] rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#5d4037" strokeWidth="2">
                <rect x="3" y="4" width="18" height="14" rx="2"/>
                <path d="M7 8h10M7 12h6"/>
              </svg>
            </div>
            <p className="mt-2 text-[13px]">View Order</p>
          </div>

          {/* Analytics */}
          {/* <div className="flex flex-col items-center">
            <div className="w-[64px] h-[64px] rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#5d4037" strokeWidth="2">
                <path d="M3 12h4v8H3zM10 8h4v12h-4zM17 4h4v16h-4z"/>
              </svg>
            </div>
            <p className="mt-2 text-[13px]">Analytics</p>
          </div> */}
        </div>

        {/* Info row */}
        <div className="mt-4 px-4 text-[13px] flex items-start gap-2">
          <span className="text-[#d9534f] text-xl leading-5">!</span>
          <p>
            Get started by adding your first product. Tap the plus
            button and begin selling today.
          </p>
        </div>

        {/* Big CTA */}
        <div className="px-4 mt-5">
          <button
            type="button"
            onClick={() => (isComplete ? navigate("/products/new") : navigate("/verify"))}
            className="w-full h-[56px] rounded-[28px] bg-[#5d4037] text-white font-semibold hover:opacity-90 transition-opacity"
          >
            {isComplete ? "Add First Product" : "Complete Profile"}
          </button>
        </div>

        {/* Bottom nav bar */}
        <div className="fixed bottom-3 md:bottom-6 left-1/2 -translate-x-1/2 w-full max-w-[1440px] xl:max-w-[1600px] px-6 md:px-10 xl:px-16">

        <div className="px-6 pt-2 pb-4 bg-white border-t border-[#eadfb7]">
            <div className="grid grid-cols-4 gap-4 text-[12px] text-[#5d4037]">
            {/* Overview (active) */}
            <div className="flex flex-col items-center">
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
              
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24">
                    <path d="M3 10.5L12 4l9 6.5" />
                    <path d="M5 10v10h14V10" />
                </svg>
                </div>
                <span className="mt-1 font-semibold">Overview</span>
            </div>

            {/* Orders */}
            <div className="flex flex-col items-center">
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
                {/* receipt icon */}
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24">
                    <rect x="4" y="3" width="16" height="18" rx="2" />
                    <path d="M8 7h8M8 11h6M8 15h8" />
                </svg>
                </div>
                <span className="mt-1 text-[#5d4037]/80">Orders</span>
            </div>

            {/* Products */}
            <div className="flex flex-col items-center">
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
           
                <div className="w-6 h-6 rounded-full border border-[#5d4037] grid place-items-center">
                    <span className="text-[11px] font-bold leading-none text-[#5d4037]">P</span>
                </div>
                </div>
                <span className="mt-1 text-[#5d4037]/80">Products</span>
            </div>

            {/* Profile */}
            <div className="flex flex-col items-center">
                <div className="w-9 h-9 rounded-[12px] bg-white border border-[#eadfb7] grid place-items-center">
                {/* user icon */}
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5d4037" strokeWidth="2">
                    <path d="M12 12a4 4 0 100-8 4 4 0 000 8z" />
                    <path d="M20 21v-2a6 6 0 00-6-6H10a6 6 0 00-6 6v2" />
                </svg>
                </div>
                <span className="mt-1 text-[#5d4037]/80">Profile</span>
            </div>
            </div>
        </div>

            
        {/* Safe-area bar with home indicator (inside the bar) */}
        <div className="h-[22px] bg-[#5d4037] flex items-center justify-center">
            <div className="w-[120px] h-[6px] rounded-full bg-white" />
        </div>
        </div>

        {/* DEV helper: toggle to final (setup3) look. Remove if not needed. */}
         {/* <div className="px-4 mt-3">
          <button onClick={() => setIsComplete(v => !v)} className="underline text-sm">
            Toggle Complete ({isComplete ? "ON" : "OFF"})
          </button>
        </div>  */}
      </div>
    </div>
  );
};
